/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceWithPaymentsErrors
 */
export interface EvidenceWithPaymentsErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'detectedDpi'?: EvidenceWithPaymentsErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'calculatedDpi'?: EvidenceWithPaymentsErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'colorGradation'?: EvidenceWithPaymentsErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'heightMillis'?: EvidenceWithPaymentsErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'widthMillis'?: EvidenceWithPaymentsErrorsWidthMillisEnum;
}

export const EvidenceWithPaymentsErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsErrorsDetectedDpiEnum = typeof EvidenceWithPaymentsErrorsDetectedDpiEnum[keyof typeof EvidenceWithPaymentsErrorsDetectedDpiEnum];
export const EvidenceWithPaymentsErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsErrorsCalculatedDpiEnum = typeof EvidenceWithPaymentsErrorsCalculatedDpiEnum[keyof typeof EvidenceWithPaymentsErrorsCalculatedDpiEnum];
export const EvidenceWithPaymentsErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceWithPaymentsErrorsColorGradationEnum = typeof EvidenceWithPaymentsErrorsColorGradationEnum[keyof typeof EvidenceWithPaymentsErrorsColorGradationEnum];
export const EvidenceWithPaymentsErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsErrorsHeightMillisEnum = typeof EvidenceWithPaymentsErrorsHeightMillisEnum[keyof typeof EvidenceWithPaymentsErrorsHeightMillisEnum];
export const EvidenceWithPaymentsErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsErrorsWidthMillisEnum = typeof EvidenceWithPaymentsErrorsWidthMillisEnum[keyof typeof EvidenceWithPaymentsErrorsWidthMillisEnum];


